import {
    $, addAction, INIT, LAYOUTEND,
} from '@situation/setdesign.util';

// Parallax for the quote-section background images (see _quote-parallax.scss).
// SetDesign's SCROLL action is throttled to 100ms, so this paces itself with rAF instead.
const OVERSCAN = 0.25; // must match the top/bottom inset in _quote-parallax.scss
addAction(INIT, () => {
    const $sections = $('.quote-section');
    if (!$sections.length) {
        return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = null;

    const update = () => {
        frame = null;

        if (reducedMotion.matches) {
            return;
        }

        const viewportHeight = window.innerHeight;
        $sections.each((index, section) => {
            const rect = section.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > viewportHeight) {
                return;
            }

            // -1 as the section enters from below, 1 as it leaves at the top.
            const travel = viewportHeight + rect.height;
            const progress = Math.min(1, Math.max(-1, ((viewportHeight - rect.top) / travel) * 2 - 1));
            section.style.setProperty('--parallax-y', `${(progress * rect.height * OVERSCAN).toFixed(1)}px`);
        });
    };

    const requestUpdate = () => {
        if (frame === null) {
            frame = window.requestAnimationFrame(update);
        }
    };

    const toggle = () => {
        const enabled = !reducedMotion.matches;
        $sections.toggleClass('is-parallax', enabled);

        if (enabled) {
            update();
        } else {
            $sections.each((index, section) => section.style.removeProperty('--parallax-y'));
        }
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    addAction(LAYOUTEND, requestUpdate);
    reducedMotion.addEventListener('change', toggle);
    toggle();
});
